'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const SocketResponse=require('../../../../dist-es6/client/dtos/socketResponse');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;let

TimelineSettingsController=(_class=class TimelineSettingsController extends BaseController{
constructor($timeout,
uncaughtErrorHandler,
notificationService,
socketService,
uiCommandFactory,
breadcrumbsService,
userService,
displaySettingsService){
super(uncaughtErrorHandler,$timeout);

this._$timeout=$timeout;
this._notificationService=notificationService;
this._socketService=socketService;
this._uiCommandFactory=uiCommandFactory;
this._userService=userService;
this._displaySettingsService=displaySettingsService;

this._controllerInitialized=!1;

this._timelineSettingsChangedCommand=this._uiCommandFactory.make(newValue=>this._updateTimelineSettings(newValue));

breadcrumbsService.startTrail('Timeline Settings');

this._loadSettings({reloadFromServer:!1});
}


async _updateTimelineSettings(use24HourTimeline){
const updateResponse=await this._socketService.sendAndWaitForResponse('SetTimelineSettings',{use24HourTimeline});

if(!SocketResponse.succeeded(updateResponse)){
this._notificationService.displayNotification('Failed to update timeline settings.','error');
}

await this._loadSettings({reloadFromServer:!0});
}


async _loadSettings({reloadFromServer}){
_.ensureInstanceOf('boolean',reloadFromServer);

if(reloadFromServer){
const socketResponse=await this._userService.continueUserSession();
if(!SocketResponse.succeeded(socketResponse)){
this._notificationService.displayNotification('Failed to retrieve timeline settings.','error');
}
}

if(!this._displaySettingsService.isLoaded){

return;
}

this._use24HourTimeline=this._displaySettingsService.use24HourTimeline;
this._controllerInitialized=!0;
this._triggerDigest();
}

get use24HourTimeline(){
return this._use24HourTimeline;
}

set use24HourTimeline(use24HourTimeline){
if(typeof use24HourTimeline!='boolean'){
return;
}

this._use24HourTimeline=use24HourTimeline;
this._timelineSettingsChangedCommand.execute(use24HourTimeline);
}},(_applyDecoratedDescriptor(_class.prototype,'_updateTimelineSettings',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_updateTimelineSettings'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_loadSettings',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_loadSettings'),_class.prototype)),_class);


module.exports=TimelineSettingsController;
//# sourceMappingURL=timelineSettingsController.js.map
